import api from './index';
//
let exports = {};

// 资产类别-列表
exports.getAssetKindList = function (params, callback) {
    api.post('/rent/asset/kind/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getDevcGroupListByContext = function (data, callback) {// 查询设备分类分组
    api.post('/rent/asset/devc/group/list/get/by/context')
    .data(data)
    .done(callback)
    .go();
};

// 设备信息单-默认服务商
exports.getShopDeviceServicer = function (data, callback) {
    api.post('/rent/asset/servcer/get/deviceId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateMaintPlanDeviceByDeviceIds = function (params, callback) { // 修改保养计划中服务商及合约信息
    api.post('/rent/asset/maint/plan/device/servicer/update/do/by/deviceIds')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改检验计划中的服务商信息
exports.updateInspectPlanDevcByDeviceIds = function (data, callback) {
    api.post('/rent/asset/plan/device/update/do/by/deviceIds')
    .data(data)
    .done(callback)
    .go();
};

// 设备查询
exports.getShopDeviceSvcSubNoListByFilter = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/list/get/by/filter')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改设备的检验信息
exports.updateShopDeviceSvcSubNoInspectFlagByIds = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/inspectFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 修改批次的验收信息
exports.updateShopDeviceSvcSubNoMainFlagByIds = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/maintFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改批次的巡检信息
exports.updateShopDeviceSvcSubNoPatrolFlagByIds = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/patrolFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改批次的安装信息
exports.updateShopDeviceSvcSubNoSetupFlagByIds = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/setupFlag/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改设备的检验流程信息
exports.updateShopDeviceSvcSubNoInspectFlowIdByIds = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/inspectFlowId/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改设备的检验流程信息
exports.updateShopDeviceSvcSubNoInspectFlowIdById = function (data, callback) {
    api.post('/rent/asset/svc/sub/no/inspectFlowId/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改设备的检验流程信息
exports.getDevcInspectInfoList = function (data, callback) {
    api.post('/rent/asset/devc/inspect/info/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ====================== 设备租赁/归还单 ==================
// 获取发生过租用关系的客户列表
exports.getRetailerListByLeaserId = function (data, callback) {
    api.post('/rent/asset/devc/rent/retailer/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取设备租赁/归还单分页列表
exports.getDevcRentVouchers = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取设备租赁/归还单
exports.getDevcRentVoucherInfo = function (params, callback) {
    api.get('/rent/asset/devc/rent/voucher/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存设备租赁/归还单
exports.saveDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存设备归还单
exports.saveDevcRentGHVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/gh/voucher/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 提交设备租赁/归还单
exports.doSubmitDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/submit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 确认设备租赁/归还单
exports.doConfirmDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/confirm/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备租赁/归还单发货操作
exports.doSendDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/send/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备租赁/归还单确认到达操作
exports.doConfirmArriveDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/confirm/arrive/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除设备租赁/归还单
exports.deleteDevcRentVoucher = function (data, callback) {
    api.post('/rent/asset/devc/rent/voucher/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/rentAsset.js
// module id = 52
// module chunks = 1